import React from "react";
// import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// import Button from "@material-ui/core/Button";
import MainLayout from "../../components/layout/MainLayout";
import DefaultHeader from "../../components/layout/Header/DefaultHeader";
import CancerTwoBuFooter from "../../components/layout/Footer/CancerTwoBuFooter";
// import FormList from "./FormList";

const useStyles = makeStyles((theme) => ({
  header: {
    marginTop: 284,
    marginBottom: 100,
    [theme.breakpoints.down("lg")]: {
      paddingLeft: 20,
      paddingRight: 20,
      marginTop: 190,
      marginBottom: 0,
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 20,
      paddingRight: 20,
      marginTop: 52,
      marginBottom: 0,
    },
  },
  title: {
    marginBottom: 18,
    lineHeight: 1.6,
  },
  body: {
    marginTop: 24,
    marginBottom: 110,
  },
}));
const LungVideoComple = ({ cancer = "폐암", onViChange, vi }) => {
  const classes = useStyles();

  return (
    <MainLayout
      header={<DefaultHeader cancer={cancer} />}
      footer={
        <CancerTwoBuFooter
          name1="재시청 하기"
          name2="완료"
          onClick1={() => onViChange(0)}
          onClick2={() => onViChange(2)}
        />
      }
    >
      <Grid
        container
        justify="center"
        alignItems="center"
        direction="column"
        className={classes.header}
      >
        <Typography variant="h2" className={classes.title} align="center">
          {cancer} 검진에 대한 동영상 시청을 마쳤습니다.
          <br />
          {cancer} 검진의 이득과 손해에 대해 이해하는데 도움이 되셨나요?
        </Typography>
      </Grid>
      <Grid
        container
        className={classes.body}
        justify="space-between"
        alignItems="center"
        direction="column"
      ></Grid>
    </MainLayout>
  );
};

export default LungVideoComple;
